export interface BuildInfo {
  sha: string;
  builtAt: string;
}

export const buildInfo = {
  sha: __BUILD_SHA__,
  ref: __BUILD_REF__,
  message: __BUILD_MSG__,
  url: __BUILD_URL__,
  builtAt: __BUILD_TIME__,
};

export const build: BuildInfo = {
  sha: buildInfo.sha || 'unknown',
  builtAt: buildInfo.builtAt || new Date().toISOString(),
};
